import React, {
 InputHTMLAttributes, ChangeEvent, useState, useEffect
} from 'react';
import { AiOutlineQuestionCircle } from 'react-icons/ai';
import MaskedInput from 'react-input-mask';
import Tooltip from '../Tooltip';
import { Content, Label } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  onChangeValue: (value: string) => void;
  width?: string;
  borderSuccessLength?: number;
  tooltip?: string;
  mask?: string;
  value?: string;
  invalid?: boolean;
}

const Input: React.FC<InputProps> = ({
  mask = null,
  width,
  onChangeValue,
  borderSuccessLength,
  tooltip,
  placeholder,
  value,
  invalid = false,
  ...rest
}) => {
  const [isActive, setIsActive] = useState(false);

  const handleInput = (event: ChangeEvent<HTMLInputElement>) => {
    const text = event.target?.value;

    if (onChangeValue) {
      onChangeValue(text);
    }
  };

  useEffect(() => {
    if (value !== '') {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [value]);

  return (
    <Content invalid={invalid} className={width} borderSuccessLength={borderSuccessLength}>
      <Label isActive={isActive}>{placeholder}</Label>

      {mask ? (
        <MaskedInput mask={mask} onChange={handleInput} autoComplete="off" value={value} {...rest} />
      ) : (
        <input onChange={handleInput} autoComplete="off" value={value} {...rest} />
      )}

      {tooltip && (
        <span className="icon is-right">
          <Tooltip text={tooltip}>
            <AiOutlineQuestionCircle />
          </Tooltip>
        </span>
      )}
    </Content>
  );
};

export default Input;
